module.exports = __webpack_public_path__ + "fonts/proxima-nova.bf9f5d50.otf";